import { render } from "./activity-log-list.vue?vue&type=template&id=2411deeb&ts=true&lang=pug"
import script from "./activity-log-list.vue?vue&type=script&lang=ts"
export * from "./activity-log-list.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__